<template>
    <v-card class="ma-3 pa-5">
        <h3>AF0 start date</h3>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">
                        Country
                    </th>
                    <th class="text-center" width="15%">
                        Date
                    </th>
                    <th class="text-right" width="5%"/>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="country in countries"
                    :key="`sensor_${country.id}`"
                >
                    <td>{{ country.name }}</td>
                    <td>
                        <v-menu
                            v-model="menu[country.id]"
                            :close-on-content-click="false"
                            min-width="auto"
                            offset-y
                            transition="scale-transition"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :value="formatDate(country.af0_start_date)"
                                    label="AF0 start date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="country.af0_start_date"
                            ></v-date-picker>
                        </v-menu>
                    </td>
                    <td class="text-right">
                        <v-btn color="primary" small @click="handleUpdateCountry(country)">Save</v-btn>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>

    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';

export default {
    name: 'StationSensorsCard',
    data() {
        return {
            menu: {},
        };
    },
    computed: {
        ...mapState('country', ['countries']),
        formatDate() {
            return (date) => {
                return moment(date).format('MM-DD');
            };
        },
    },
    async mounted() {
        await this.fetchCountries();
        this.countries.forEach(c => {
            this.menu[c.id] = false;
        });
    },
    methods: {
        ...mapActions('country', ['fetchCountries', 'saveCountry']),
        async handleUpdateCountry(country) {
            await this.saveCountry({country})
            this.menu[country.id] = false
        },
    },
};
</script>